if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute('available')) return;

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

fetchAvailability(variantId) {
  if (!variantId) return;

  let rootUrl = this.dataset.rootUrl;
  if (!rootUrl.endsWith('/')) {
    rootUrl = rootUrl + '/';
  }
  const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

  fetch(variantSectionUrl)
    .then((response) => response.text())
    .then((text) => {
      const doc = new DOMParser().parseFromString(text, 'text/html');
      // A veces Shopify NO envuelve con .shopify-section
      const sectionInnerHTML = doc.querySelector('.shopify-section') || doc.body || doc;
      this.renderPreview(sectionInnerHTML);
    })
    .catch((e) => {
      const button = this.querySelector('button');
      if (button) button.removeEventListener('click', this.onClickRefreshList);
      this.renderError();
    });
}


      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.available) {
          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute('available');
          this.innerHTML = '';
        }
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        this.querySelector('button').addEventListener('click', this.onClickRefreshList);
      }

renderPreview(sectionInnerHTML) {
  const drawer = document.querySelector('pickup-availability-drawer');
  if (drawer) drawer.remove();

  // Busca el preview y el drawer aunque no exista el wrapper .shopify-section
  const previewEl =
    sectionInnerHTML.querySelector('pickup-availability-preview') ||
    sectionInnerHTML.querySelector('pickup-availability') || // por si el section devuelve el custom element directo
    null;

  const drawerEl = sectionInnerHTML.querySelector('pickup-availability-drawer');

  if (!previewEl) {
    this.innerHTML = '';
    this.removeAttribute('available');
    return;
  }

  this.innerHTML = previewEl.outerHTML;
  this.setAttribute('available', '');

  if (drawerEl) {
    document.body.appendChild(drawerEl);
    const colorClassesToApply = (this.dataset.productPageColorScheme || '').split(' ').filter(Boolean);
    colorClassesToApply.forEach((colorClass) => {
      document.querySelector('pickup-availability-drawer').classList.add(colorClass);
    });
  }

  const button = this.querySelector('button');
  if (button && drawerEl) {
    button.addEventListener('click', (evt) => {
      document.querySelector('pickup-availability-drawer').show(evt.target);
    });
  }
}

    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector('button').addEventListener('click', () => {
          this.close();
        });

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.close();
        });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target != this &&
          !target.closest('pickup-availability-drawer') &&
          target.id != 'ShowPickupAvailabilityDrawer'
        ) {
          this.close();
        }
      }

      close() {
        this.classList.remove('animate');
        setTimeout(() => {
          this.classList.remove('active');
          document.body.classList.remove('overflow-hidden');
          document.body.style.paddingRight = '';
        }, 500);
        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        setTimeout(() => {
          this.classList.add('active');
          this.classList.add('animate');
        });
        document.body.style.paddingRight = this.getScrollbarWidth() + 'px';
        document.body.classList.add('overflow-hidden');
        
        this.focusElement = focusElement;
        trapFocus(this);
      }
      getScrollbarWidth() {
        return window.innerWidth - document.documentElement.clientWidth;
      }
    }
  );
}
